import React, { PureComponent } from 'react';

import styles from './styles.less';

export default class Message extends PureComponent<{
	children: React.ReactNode;
}> {
	render() {
		return <p className={styles.warning}>{this.props.children}</p>;
	}
}
